import { lazy } from "react";
import { routeFor } from "./data/routes.mjs";

export const PAGE_LOADERS = {
  Concepts: () => import("./pages/Concepts"),
  ConceptDemo: () => import("./pages/ConceptDemo"),
  Home: () => import("./pages/Home"),
  Services: () => import("./pages/Services"),
  WebsiteDesign: () => import("./pages/WebsiteDesign"),
  WebsitePackages: () => import("./pages/WebsitePackages"),
  SupportCare: () => import("./pages/SupportCare"),
  ServicePage: () => import("./pages/ServicePage"),
  AdelaideWebDesign: () => import("./pages/AdelaideWebDesign"),
  AdelaideLocalPage: () => import("./pages/AdelaideLocalPage"),
  Pricing: () => import("./pages/Pricing"),
  About: () => import("./pages/About"),
  CaseStudyKhimThai: () => import("./pages/CaseStudyKhimThai"),
  Contact: () => import("./pages/Contact"),
  Privacy: () => import("./pages/Privacy"),
  Terms: () => import("./pages/Terms"),
  NotFound: () => import("./pages/NotFound"),
};
export const LAZY_PAGES = Object.fromEntries(
  Object.entries(PAGE_LOADERS).map(([name, loader]) => [name, lazy(loader)]),
);
export const pageNameFor = (path) => routeFor(path)?.component || "NotFound";
